// extracted by mini-css-extract-plugin
module.exports = {"price":"price-13Eel","price__text":"price__text-YmGiS","price__money":"price__money-bhLWf","selectedFare__priceWrapper":"selectedFare__priceWrapper-1e7aW"};